import moment from 'moment';
import _ from 'lodash';
import { makeAutoObservable } from 'mobx';
import { defaultAxios } from '@/utils';
import { Modal } from 'antd';
import React from 'react';
import { createDefaultInstanceGetterA } from '@/stores/utilsA';

export type TNewSignReturnType = NetResponse<{
    data: any[];
    msg: string;
    code: number;
}>;

const api = '/crm/data/query/list_new_sign_indicator_change';

export class NewSignStore {
    constructor() {
        makeAutoObservable(this);
    }
    public newSignAnaData: any[] = [];
    public getNewSignData: (
        searchData: any,
    ) => Promise<TNewSignReturnType> = async searchData => {
        const finalSearchData = {
            ...searchData,
            api,
        };
        const url = '/bff/api/rest/ana/common/fetch';
        const [d, e] = await defaultAxios.post(url, finalSearchData);
        if (d === null || d.data === null) {
            return [null, e];
        }
        const data = d.data;
        if (data && Array.isArray(data)) {
            this.newSignAnaData = data;
        }
        const error = e as Error | null;
        return [data, error];
    };
    public exportNewSignData = async (searchData: any, fileName: string) => {
        if (this.newSignAnaData.length > 10000) {
            Modal.error({
                title: '导出提示',
                content: (
                    <p>
                        最多支持导出10000条（当前条件共
                        {this.newSignAnaData.length}
                        条，请更换筛选条件再导出
                    </p>
                ),
            });
            return;
        }
        const url = `${
            window.location.origin
        }/bff/api/rest/ana/common/export?q=${encodeURIComponent(
            JSON.stringify({ ...searchData, fileName, api }),
        )}`;
        window.open(url, '_blank');
        return;
    };
}

export const getDefaultNewSignStore = createDefaultInstanceGetterA(
    NewSignStore,
);
